// extracted by mini-css-extract-plugin
module.exports = {"container":"Microphone_container__S9aIx","header":"Microphone_header__1RNx5","wave":"Microphone_wave__IdFkV"};